import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Form, InputGroup, Modal } from "react-bootstrap"
import { useForm } from "react-hook-form";
import { z } from "zod"
import Select from "react-select";
import useLocalStorageState from "use-local-storage-state";
import { useGetRequest, usePostRequest } from "../Utils/hooks/QueryHandler";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { customStyles } from "../Utils/helpers/commonhelper";
//  VALIDATION SCHEMA FOR FORM
const schema = z.object({
    name: z.string().min(1, "Lead source is required"),
    description: z.string().optional(),
    status: z.enum(["Active", "Inactive"], {
        required_error: "Status is required",
    }),
});

export const UsersPopup = ({ setRecentSourceId, sourceShow, setSourceShow }) => {
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm({ resolver: zodResolver(schema) });

    const navigate = useNavigate()
    const [leadSources, setLeadSources] = useState([]);
    const [customer, setCustomer] = useLocalStorageState("customer")

    // TOKEN HEADERS FOR API  Request
    const customerId = customer?.customer_details?.customer_id;
    const token = customer?.token?.authorization;
    const rf = customer?.token?.authentication;
    const headers = {
        authentication: rf,
        Authorization: token,
    };
    const extras = { customer, setCustomer, rf, navigate };

    const {
        data: leadSourcesData,
        error,
        isError
    } = useGetRequest(
        `masters/getAllLead_source/${customerId}`,
        "getLeadSource",
        headers,
        extras
    );

    // Fetch departments on component mount
    useEffect(() => {
        if (leadSourcesData?.status === "success") {
            setLeadSources(leadSourcesData.data);
        } else if (isError) {
            console.error("Error fetching roles:", error);
        }
    }, [leadSourcesData, isError]);

    // mutate for creating lead source
    const { mutate: addLead_source } = usePostRequest(
        `masters/addLead_source`,
        null,
        { headers },
        extras
    );

    const onSubmit = async (formData) => {
        const name = formData.name.trim();
        const description = formData.description?.trim() || "";
        const status = formData.status;
        // Check for duplicate name
        const isDuplicate = leadSources.some(
            (d) => d.source_title.trim() === name
        );
        if (isDuplicate) {
            toast.error("Duplicate LeadSource name ");
            return;
        }
        try {
            const payload = {
                customer_id: customerId,
                login_user_id: customer.customer_details?.id,
                source_title: name,
                lead_source: name,
                description,
                status,
            };
            addLead_source(payload, {
                onSuccess: (res) => {
                    if (res?.status === "success") {
                        toast.success(res.message || "Role added successfully");
                        setRecentSourceId(prev => ({
                            ...prev,
                            recentSourceId: String(res.data)
                        }))
                        setSourceShow(false)
                        reset({ name: "", description: "", status: "Active" });
                    } else {
                        toast.error(res.message || "Failed to add role");
                    }
                },
                onError: (err) => {
                    toast.error(err?.message || "Add role request failed");
                },
            });

        } catch (err) {
            // console.error("Submit error:", err);
            toast.error("Error Submitting Data!")
        }
    };
    return (
        <Modal
            size="md"
            centered
            show={sourceShow}
            onHide={() => setSourceShow(false)}
            contentClassName="border-0 shadow-lg rounded-3"
        >
            {/* Consistent Brand Header */}
            <Modal.Header closeButton className="border-bottom-0 pt-4 px-4 align-items-start">
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-start mb-1 gap-2">
                        <div
                            className="d-flex align-items-center justify-content-center rounded-2"
                            style={{
                                background: "linear-gradient(135deg, #7a3a5e 0%, #4f243c 100%)",
                                width: "38px",
                                height: "38px",
                                boxShadow: "0 4px 10px rgba(122, 58, 94, 0.2)"
                            }}
                        >
                            <i className="fa-solid fa-code-branch fs-6" style={{ color: "white" }}></i>
                        </div>
                        <div className="d-flex flex-column">
                            <Modal.Title className="h5 fw-bold m-0" style={{ color: '#1a202c' }}>
                                Add Lead Source
                            </Modal.Title>
                            <small className="text-muted ">
                                Create a new origin point for your incoming leads.
                            </small>
                        </div>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body className="px-4 py-3">
                <Form className="form-container" onSubmit={handleSubmit(onSubmit)}>
                    {/* Input Field */}
                    <Form.Group className="mb-3 focus-z-index position-relative ">
                        <Form.Label className="small fw-semibold text-secondary text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                            Enquiry Source <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            {...register("name")}
                            placeholder="e.g. Google Ads, Referral..."
                            style={{ fontSize: '14px', borderRadius: '6px', padding: '10px' }}
                            isInvalid={!!errors.name}
                        />
                        {errors.name && (
                            <Form.Control.Feedback type="invalid">{errors.name.message}</Form.Control.Feedback>
                        )}
                    </Form.Group>

                    {/* Textarea Field */}
                    <Form.Group className="mb-3 focus-z-index position-relative ">
                        <Form.Label className="small fw-semibold text-secondary text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                            Description <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            {...register("description")}
                            placeholder="Brief details about this source..."
                            style={{ fontSize: '14px', borderRadius: '6px', resize: 'none' }}
                        />
                    </Form.Group>

                    {/* Status Select */}
                    <Form.Group className="mb-4 focus-z-index position-relative">
                        <Form.Label className="small fw-semibold text-secondary text-uppercase" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                            Lead Status <span className="text-danger">*</span>
                        </Form.Label>
                        <Select
                            styles={{
                                ...customStyles,
                            }}
                            options={[
                                { value: "Active", label: "Active" },
                                { value: "Inactive", label: "Inactive" }
                            ]}
                            onChange={(selectedOption) => {
                                if (selectedOption) {
                                    setValue("status", selectedOption.value, { shouldValidate: true });
                                }
                            }}
                            isClearable
                            placeholder="Select status..."
                            classNamePrefix="react-select"
                        />
                        {errors.status && (
                            <small className="text-danger mt-1 d-block">{errors.status.message}</small>
                        )}
                    </Form.Group>

                    {/* Standardized Footer Buttons */}
                    <div className="d-flex gap-2 align-items-center justify-content-end mt-4 pt-2">
                        <button
                            type="button"
                            onClick={() => {
                                reset();
                                setSourceShow(false);
                            }}
                            className="px-3 py-2 fw-medium transition-all"
                            style={{
                                backgroundColor: "#ffffff",
                                color: "#64748b",
                                border: "1px solid #dee2e6",
                                fontSize: "13px",
                                borderRadius: "6px",
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 fw-semibold shadow-sm transition-all"
                            style={{
                                backgroundColor: "#7a3a5e",
                                color: "#fff",
                                border: "none",
                                fontSize: "14px",
                                borderRadius: "6px",
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}
